import React, {useEffect,useState,} from "react";

const initialState = {
  username: "",
  password: "",
  firstName: "",
  lastName: "",
  email: "",
  mobileNo: "",
  roleId: "",
  hubIds: [],
  is_active: true,
  superAdmin: false,
  forcePasswordChange: true,
};

const UserModal = ({user,roles,hubs,onClose,refreshUsers,}) => {
  const [formData, setFormData] = useState(initialState);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (user) {
      setFormData({
        username:user.username || "",
        password: "",
        firstName:user.firstName || "",
        lastName:user.lastName || "",
        email:user.email || "",
        mobileNo:user.mobileNo || "",
        roleId:String(user.roleId ?? ""),
        hubIds:user.hubIds || [],
        is_active:user.is_active,
        superAdmin:user.superAdmin,
        forcePasswordChange:user.forcePasswordChange,
      });
    } else {
      setFormData({ ...initialState });
    }
  }, [user]);

  const handleChange = (e) => {
    const {name,value,checked,type,} = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]:type === "checkbox"
          ? checked
          : value,
    }));
  };

  const toggleHub = (hubId) => {
    setFormData((prev) => ({
      ...prev,
      hubIds:prev.hubIds.includes(hubId)
          ? prev.hubIds.filter((id) => id !== hubId)
          : [
              ...prev.hubIds,
              hubId,
            ],
    }));
  };

  const validate = () => {
    if (!formData.username.trim()) {
      alert("Username is required");
      return false;
    }

    if (!user && !formData.password) {
      alert("Password is required");
      return false;
    }

    if (!formData.roleId) {
      alert("Please select role");
      return false;
    }

    if (formData.mobileNo && formData.mobileNo.length !==10) {
      alert("Mobile number must be 10 digits");
      return false;
    }

    return true;
  };

  const handleSubmit = async (e) => { 
    e.preventDefault();
      if (!validate()) {
        return;
      }

      try {
        setSaving(true);
        console.log("user====",user)
        const endpoint = user
            ? `${process.env.REACT_APP_FORE_APILINK}/admin/update-user?id=${user._id}`
            : `${process.env.REACT_APP_FORE_APILINK}/admin/create-user`;
        const method = user ? "PUT": "POST";
        const response = await fetch(endpoint,
            {
              method,
              headers: {
                "Content-Type":
                "application/json",
              },
              body:JSON.stringify(formData),
            }
          );
        const result = await response.json();
        if (!response.ok) {
          throw new Error(result.message);
        }
        alert(user
            ? "User Updated Successfully"
            : "User Created Successfully"
        );
        refreshUsers();
        onClose();
      } catch (error) {
        alert(error.message);
      } finally {
        setSaving(false);
      }
    };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4">
      <div className="max-h-[90vh] w-full max-w-5xl overflow-y-auto rounded-xl bg-white p-6">
        <div className="mb-5 flex items-center justify-between">
          <h2 className="text-xl font-semibold">
            {user
              ? "Edit User"
              : "Create User"}
          </h2>
          <button onClick={onClose}>✕</button>
        </div>

        <form
          onSubmit={handleSubmit}
          className="grid grid-cols-2 gap-4"
        >
          {/* Username */}
          <div>
            <label className="mb-1 block text-sm font-medium">Username</label>
            <input name="username"
              value={formData.username}
              onChange={handleChange}
              className="w-full rounded-lg border px-3 py-2"
            />
          </div>

          {/* Password */}
          {!user && (
            <div>
              <label className="mb-1 block text-sm font-medium">Password</label>
              <input
                type="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                className="w-full rounded-lg border px-3 py-2"
              />
            </div>
          )}

          <div>
            <label className="mb-1 block text-sm font-medium">First Name</label>
            <input
              name="firstName"
              value={formData.firstName}
              onChange={handleChange}
              className="w-full rounded-lg border px-3 py-2"
            />
          </div>

          <div>
            <label className="mb-1 block text-sm font-medium">Last Name</label>
            <input name="lastName"
              value={formData.lastName}
              onChange={handleChange}
              className="w-full rounded-lg border px-3 py-2"
            />
          </div>

          <div>
            <label className="mb-1 block text-sm font-medium">Email</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              className="w-full rounded-lg border px-3 py-2"
            />
          </div>

          <div>
            <label className="mb-1 block text-sm font-medium">Mobile Number</label>
            <input
              name="mobileNo"
              value={formData.mobileNo}
              onChange={handleChange}
              className="w-full rounded-lg border px-3 py-2"
            />
          </div>

          {/* Role */}
          <div className="col-span-2">
            <label className="mb-1 block text-sm font-medium">Role</label>
            <select
              name="roleId"
              value={formData.roleId}
              onChange={handleChange}
              className="w-full rounded-lg border px-3 py-2"
            >
              <option value="">Select Role</option>
              {console.log("Roles in UserModal:", roles)}
              {roles.map((role) => (
                  <option
                    key={role.roleId}
                    value={role.roleId}>
                    {role.roleName}
                  </option>
                )
              )}
            </select>
          </div>

          {/* Hubs */}
          <div className="col-span-2">
            <label className="mb-2 block text-sm font-medium">Assigned Hubs</label>
            <div className="grid grid-cols-4 gap-3">
              {hubs.map((hub) => (
                  <label key={hub._id} className="flex items-center gap-2 rounded border p-2">
                    <input type="checkbox" checked={formData.hubIds.includes(hub._id)}
                      onChange={() => toggleHub(hub._id)}
                    />
                    <span>{hub.hub_name}</span>
                  </label>
                )
              )}
            </div>
          </div>

          {/* Settings */}
          <div className="col-span-2 mt-4">
            <div className="grid grid-cols-3 gap-4">
              <label className="flex items-center gap-2">
                <input
                  type="checkbox"
                  name="is_active"
                  checked={formData.is_active}
                  onChange={handleChange}
                />Active User
              </label>

              <label className="flex items-center gap-2">
                <input
                  type="checkbox"
                  name="superAdmin"
                  checked={formData.superAdmin}
                  onChange={handleChange}
                />Super Admin
              </label>

              <label className="flex items-center gap-2">
                <input
                  type="checkbox"
                  name="forcePasswordChange"
                  checked={formData.forcePasswordChange}
                  onChange={handleChange}
                />Force Password Change
              </label>
            </div>
          </div>

          {/* Footer */}
          <div className="col-span-2 mt-6 flex justify-end gap-3">
            <button
              type="button"
              onClick={onClose}
              className="rounded-lg border px-4 py-2"
            >
              Cancel
            </button>

            <button
              type="submit"
              disabled={saving}
              className="rounded-lg bg-[#F7525A] px-5 py-2 text-white"
            >
              {saving ? "Saving..." : user? "Update User" : "Create User"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default UserModal;